window.ThemeUtils = window.ThemeUtils || {};

(function () {
  'use strict';

  var STOP_WORDS = new Set([
    'de', 'del', 'la', 'las', 'el', 'los', 'para', 'por', 'con', 'sin',
    'un', 'una', 'unos', 'unas', 'y', 'en'
  ]);

  /* Intenciones comerciales de alta confianza. Solo se incluyen familias
     cuyo product_type está normalizado en el índice. El fallback nunca mezcla
     accesorios con el instrumento principal. */
  var INTENTS = [
    {
      key: 'organeta',
      aliases: ['organeta', 'organetas'],
      query: 'organeta',
      productTypes: ['Teclado portátil'],
      alternativeVendors: ['Casio', 'Roland'],
      preset: 'cur-organeta'
    },
    {
      key: 'teclado',
      aliases: ['teclado', 'teclados', 'keyboard'],
      query: 'teclado',
      productTypes: ['Teclado portátil'],
      preset: null
    },
    {
      key: 'grabadora',
      aliases: ['grabadora', 'grabadoras', 'recorder'],
      query: 'grabadora',
      productTypes: ['Grabadora portátil'],
      preset: null
    }
  ];

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokens(value) {
    return normalize(value).split(' ').filter(function (token) {
      return token.length >= 2 && !STOP_WORDS.has(token);
    });
  }

  function isIdentifier(value) {
    return /^\d{5,32}$/.test(String(value || '').trim());
  }

  function normalizeModelQuery(value) {
    var normalized = String(value || '').trim()
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/\b([a-z]{1,5})\s+(\d[a-z0-9]*)\b/gi, function (match, prefix, number) {
        return STOP_WORDS.has(prefix.toLowerCase()) ? match : prefix + number;
      })
      .replace(/\b([a-z]{1,3})\s+([a-z]{1,2}\d[a-z0-9]*)\b/gi, function (match, prefix, number) {
        return STOP_WORDS.has(prefix.toLowerCase()) ? match : prefix + number;
      })
      .replace(/\b(?=[a-z0-9./-]*[a-z])(?=[a-z0-9./-]*\d)[a-z0-9]+(?:[-/.][a-z0-9]+)+\b/gi, function (model) {
        return model.replace(/[-/.]/g, '');
      });
    var parts = normalized.split(/\s+/);
    var modelIndex = -1;
    parts.forEach(function (part, index) {
      if (/^(?=.*[a-z])(?=.*\d)[a-z0-9]+$/i.test(part)) modelIndex = index;
    });
    if (modelIndex !== -1 && modelIndex < parts.length - 1) {
      parts.push(parts.splice(modelIndex, 1)[0]);
      return parts.join(' ');
    }
    return normalized;
  }

  function fetchSearch(url, options) {
    var parsed = new URL(url);
    var query = parsed.searchParams.get('q') || '';
    var normalized = normalizeModelQuery(query);
    var hasTitle = (parsed.searchParams.get('query_by') || '').split(',').indexOf('title') !== -1;
    return fetch(url, options).then(function (response) {
      if (!response.ok || !hasTitle || isIdentifier(query) || normalized === query) return response;
      return response.clone().json().then(function (data) {
        if (data.found !== 0) return response;
        parsed.searchParams.set('q', normalized);
        return fetch(parsed.toString(), options);
      });
    });
  }

  function resolveIntent(value) {
    var queryTokens = tokens(value);
    for (var i = 0; i < INTENTS.length; i += 1) {
      var intent = INTENTS[i];
      var matchedAlias = intent.aliases.find(function (alias) {
        return queryTokens.indexOf(normalize(alias)) !== -1;
      });
      if (matchedAlias) {
        return {
          key: intent.key,
          query: intent.query,
          productTypes: intent.productTypes.slice(),
          alternativeVendors: (intent.alternativeVendors || []).slice(),
          preset: intent.preset,
          matchedAlias: matchedAlias,
          originalQuery: String(value || '').trim()
        };
      }
    }
    return null;
  }

  function typesenseParams(value, approximate) {
    if (isIdentifier(value)) {
      return {
        query_by: 'sku',
        query_by_weights: '1',
        num_typos: '0',
        typo_tokens_threshold: '0',
        drop_tokens_threshold: '0',
        prefix: 'false',
        enable_typos_for_numerical_tokens: 'false',
        enable_typos_for_alpha_numerical_tokens: 'false',
        prioritize_exact_match: 'true'
      };
    }

    var allowTypos = approximate && !/\d/.test(String(value || ''));
    return {
      query_by: 'title,sku,vendor,product_type',
      query_by_weights: '4,3,1,1',
      num_typos: allowTypos ? '1' : '0',
      typo_tokens_threshold: allowTypos ? '1' : '0',
      prefix: 'true,false,true,true',
      /* Una búsqueda no debe convertirse silenciosamente en otra descartando
         palabras. Las equivalencias comerciales viven en Typesense. */
      drop_tokens_threshold: '0',
      enable_typos_for_numerical_tokens: 'false',
      enable_typos_for_alpha_numerical_tokens: 'false',
      prioritize_exact_match: 'true'
    };
  }

  function filterForIntent(intent) {
    if (!intent || !intent.productTypes || !intent.productTypes.length) return '';
    var values = intent.productTypes.map(function (value) {
      return '`' + String(value).replace(/`/g, '\\`') + '`';
    });
    return 'product_type:=[' + values.join(',') + ']';
  }

  /* Typesense puede adjuntar sugerencias comerciales a una regla. El tema no
     interpreta la consulta: solo valida esos datos antes de mostrarlos. */
  function suggestedSearches(metadata) {
    if (!metadata || !Array.isArray(metadata.suggested_searches)) return [];
    return metadata.suggested_searches.filter(function (suggestion) {
      return suggestion
        && typeof suggestion.label === 'string'
        && typeof suggestion.product_type === 'string'
        && typeof suggestion.vendor === 'string';
    });
  }

  /* Presentación únicamente: intercala, en el orden definido por Typesense,
     las marcas sugeridas. No agrega ni elimina resultados y deja al final
     cualquier producto cuya marca no esté incluida en la metadata. */
  function alternateBySuggestedVendors(items, metadata) {
    var source = Array.isArray(items) ? items.slice() : [];
    var vendorKeys = [];
    suggestedSearches(metadata).forEach(function (suggestion) {
      var key = normalize(suggestion.vendor);
      if (key && vendorKeys.indexOf(key) === -1) vendorKeys.push(key);
    });
    if (vendorKeys.length < 2) return source;

    function itemVendor(item) {
      var value = item && item.document ? item.document.vendor : item && item.vendor;
      return normalize(value);
    }

    var groups = vendorKeys.map(function (vendorKey) {
      return source.filter(function (item) { return itemVendor(item) === vendorKey; });
    });
    var remaining = source.filter(function (item) {
      return vendorKeys.indexOf(itemVendor(item)) === -1;
    });
    var alternated = [];
    for (var i = 0; groups.some(function (group) { return group[i]; }); i += 1) {
      groups.forEach(function (group) {
        if (group[i]) alternated.push(group[i]);
      });
    }
    return alternated.concat(remaining);
  }

  ThemeUtils.searchIntent = {
    normalize: normalize,
    isIdentifier: isIdentifier,
    normalizeModelQuery: normalizeModelQuery,
    fetchSearch: fetchSearch,
    resolveIntent: resolveIntent,
    typesenseParams: typesenseParams,
    filterForIntent: filterForIntent,
    suggestedSearches: suggestedSearches,
    alternateBySuggestedVendors: alternateBySuggestedVendors
  };
})();
